import React, { useEffect, useState } from 'react';

import P5Wrapper from 'react-p5-wrapper';
import GOL from './sketches/GOL';

const isMobileWidth = () => typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 1023px)').matches;

const Sketch = () => {
  const initial = typeof document !== 'undefined' ? !(document.body.classList.contains('menu-open') && isMobileWidth()) : false;
  const [shouldRender, setShouldRender] = useState(initial);

  useEffect(() => {
    // Handler for our custom event from Navbar
    const onMenuToggle = (e) => {
      const open = !!(e && e.detail && e.detail.open);
      if (isMobileWidth()) {
        setShouldRender(!open);
      }
    };

    // Also listen for resize so we render on desktop widths even if menu-open was present
    const onResize = () => {
      if (!isMobileWidth()) setShouldRender(true);
      else setShouldRender(!(typeof document !== 'undefined' && document.body.classList.contains('menu-open')));
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('menu-open', onMenuToggle);
      window.addEventListener('resize', onResize);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('menu-open', onMenuToggle);
        window.removeEventListener('resize', onResize);
      }
    };
  }, []);

  if (!shouldRender) return <div className="GOL" style={{ minHeight: '40vh' }} />;

  return (
    <div className="GOL" style={{ minHeight: '40vh' }}>
      <div>
        <P5Wrapper sketch={GOL} />
      </div>
    </div>
  );
};
export default Sketch;
